const SIZES = {
  sm: "w-6 h-6 border-2",
  md: "w-10 h-10 border-3",
  lg: "w-12 h-12 border-3",
  xl: "w-16 h-16 border-4",
};

export default function Loader({ size = "md", fullScreen = false, label }) {
  const sizeClasses = SIZES[size] || SIZES.md;

  const spinner = (
    <div className={`${sizeClasses} border-muted-bg border-t-primary rounded-full animate-spin`} />
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-background z-50">
        <div className="flex flex-col items-center gap-4">
          {spinner}
          {label && <span className="text-muted text-sm font-medium">{label}</span>}
        </div>
      </div>
    );
  }

  if (label) {
    return (
      <div className="flex flex-col items-center gap-3">
        {spinner}
        <span className="text-muted text-sm font-medium">{label}</span>
      </div>
    );
  }

  return spinner;
}
